import Thumbnail from './img/thumbnail.png';
import Blog1 from './img/blog1.png';
import Blog2 from './img/blog2.png';
import Blog3 from './img/blog3.png';
import Blog4 from './img/blog4.png';
import Blog5 from './img/blog5.png';
import Blog6 from './img/blog6.png';
import Blog7 from './img/blog7.png';
import Blog8 from './img/blog8.png';
import Blog9 from './img/blog9.png';
import Blog10 from './img/blog10.png';
export const meta = {
    "home": {
        "title": "Magic Feedback. Uncover deeper insights at scale with AI",
        "description": "Magic Feedback. Collect all your customer feedback in one place and analyze it automatically at scale with AI. The best customer feedback tool. Schedule a demo",
        "og_title": "Magic Feedback. Uncover deeper insights at scale with AI",
        "og_description": "Magic Feedback. Collect all your customer feedback in one place and analyze it automatically at scale with AI. The best customer feedback tool. Schedule a demo",
        "og_image": Thumbnail,
        "og_image_width": "1200",
        "og_image_height": "1200"
    },
    "schedule-demo": {
        "title": "Magic Feedback. Schedule demo. Consult an expert. Book here",
        "description": "Magic Feedback. Schedule demo. Discover how Magic Feedback can help you uncover insights at scale. Have all your questions answered. Book a free 30 min demo",
        "og_title": "Magic Feedback. Schedule demo. Consult an expert. Book here",
        "og_description": "Magic Feedback. Schedule demo. Discover how Magic Feedback can help you uncover insights at scale. Have all your questions answered. Book a free 30 min demo",
        "og_image": Thumbnail,
        "og_image_width": "1200",
        "og_image_height": "1200"
    },
    "about": {
        "title": "Magic Feedback. About us. Our history and team. Read more",
        "description": "Magic Feedback. About us. Learn more about our mission, history and the exceptional team behind Magic Feedback. Learn more about Magic Feedback",
        "og_title": "Magic Feedback. About us. Our history and team. Read more",
        "og_description": "Magic Feedback. About us. Learn more about our mission, history and the exceptional team behind Magic Feedback. Learn more about Magic Feedback",
        "og_image": Thumbnail,
        "og_image_width": "1200",
        "og_image_height": "1200"
    },
    "blog": {
        "title": "Magic Feedback. Blog. Feedback best practices. Read more",
        "description": "Magic Feedback. Blog. Customer feedback best practices. Learn how to conduct customer interviews, surveys, discovery and much more. Read our latest blog posts",
        "og_title": "Magic Feedback. Blog. Feedback best practices. Read more",
        "og_description": "Magic Feedback. Blog. Customer feedback best practices. Learn how to conduct customer interviews, surveys, discovery and much more. Read our latest blog posts",
        "og_image": Thumbnail,
        "og_image_width": "1200",
        "og_image_height": "1200"
    },
    "pricing": {
        "title": "Magic Feedback. Pricing. Transparent pricing. Try for free",
        "description": "Magic Feedback. Pricing. Try our AI customer feedback analysis for free. The best AI-powered customer feedback analysis solution. See our pricing plans here",
        "og_title": "Magic Feedback. Pricing. Transparent pricing. Try for free",
        "og_description": "Magic Feedback. Pricing. Try our AI customer feedback analysis for free. The best AI-powered customer feedback analysis solution. See our pricing plans here",
        "og_image": Thumbnail,
        "og_image_width": "1200",
        "og_image_height": "1200"
    },
    "surveys": {
        "title": "Magic Feedback. AI Surveys. Gain deeper insights. Book demo",
        "description": "Magic Feedback. AI Surveys. Deeper & actionable customer insights at scale. Real-time follow up-questions. GDPR compliant. Instant AI Analysis. Schedule demo",
        "og_title": "Magic Feedback. AI Surveys. Gain deeper insights. Book demo",
        "og_description": "Magic Feedback. AI Surveys. Deeper & actionable customer insights at scale. Real-time follow up-questions. GDPR compliant. Instant AI Analysis. Schedule demo",
        "og_image": Thumbnail,
        "og_image_width": "1200",
        "og_image_height": "1200"
    },
    "how-to-conduct-user-interviews-as-a-product-manager": {
        "title": "How to do user interviews: Best Practices. Learn more. ",
        "description": "How to do user interviews as a product manager. User interview best practices. Interview questions examples. Learn how to conduct user interviews. Read more.",
        "og_title": "How to do user interviews: Best Practices. Learn more. ",
        "og_description": "How to do user interviews as a product manager. User interview best practices. Interview questions examples. Learn how to conduct user interviews. Read more.",
        "og_image": Blog1,
        "og_image_width": "1200",
        "og_image_height": "650"
    },
    "how-to-conduct-user-surveys-as-a-product-manager": {
        "title": "How to conduct user surveys as a product manager",
        "description": "Learn how to conduct user feedback surveys. Find examples of customer feedback survey questions. User surveys to measure user satisfaction. Find out more. ",
        "og_title": "How to conduct user surveys as a product manager",
        "og_description": "Learn how to conduct user feedback surveys. Find examples of customer feedback survey questions. User surveys to measure user satisfaction. Find out more. ",
        "og_image": Blog2,
        "og_image_width": "1200",
        "og_image_height": "650"
    },
    "beta-testing-as-a-product-manager": {
        "title": "How to do beta testing: Guide with best practices & examples",
        "description": "Learn how to beta test your product. Beta testing best practices. Complete guide to beta testing with examples. Understand the beta testing process. Learn more.",
        "og_title": "How to do beta testing: Guide with best practices & examples",
        "og_description": "Learn how to beta test your product. Beta testing best practices. Complete guide to beta testing with examples. Understand the beta testing process. Learn more.",
        "og_image": Blog3,
        "og_image_width": "1200",
        "og_image_height": "650"
    },
    "how-ceo-can-collaborate-with-cto": {
        "title": "How CEO can best collaborate with CTO. Find out more. ",
        "description": "Guide on best CEO-CTO collaboration. Understanding how to improve the CEO-CTO communication. Tips on how to align on product development. Find out more. ",
        "og_title": "How CEO can best collaborate with CTO. Find out more. ",
        "og_description": "Guide on best CEO-CTO collaboration. Understanding how to improve the CEO-CTO communication. Tips on how to align on product development. Find out more. ",
        "og_image": Blog4,
        "og_image_width": "1200",
        "og_image_height": "650"
    },
    "how-to-do-discovery-interviews-find-the-right-customers": {
        "title": "How to recruit customers for discovery interview. Learn more",
        "description": "Complete guide to customer discovery interviews. How to recruit customers for product discovery interview. Improve your product discovery process. Find out more",
        "og_title": "How to recruit customers for discovery interview. Learn more",
        "og_description": "Complete guide to customer discovery interviews. How to recruit customers for product discovery interview. Improve your product discovery process. Find out more",
        "og_image": Blog5,
        "og_image_width": "1200",
        "og_image_height": "650"
    },
    "how-to-do-discovery-interviews-customer-interview-questions": {
        "title": "How to ask better customer interview questions. Learn more. ",
        "description": "Guide to discovery interviews. How to ask the right customer interview questions. Improve product discovery. Discovery interview questions examples. Learn more.",
        "og_title": "How to ask better customer interview questions. Learn more. ",
        "og_description": "Guide to discovery interviews. How to ask the right customer interview questions. Improve product discovery. Discovery interview questions examples. Learn more.",
        "og_image": Blog6,
        "og_image_width": "1200",
        "og_image_height": "650"
    },
    "6-biggest-customer-interview-mistakes": {
        "title": "6 customer interviews mistakes. Learn how to avoid them.",
        "description": "Find the 6 biggest customer interview mistakes. Learn how avoiding confirmation bias and leading questions will improve your customer interviews. Find out more",
        "og_title": "6 customer interviews mistakes. Learn how to avoid them.",
        "og_description": "Find the 6 biggest customer interview mistakes. Learn how avoiding confirmation bias and leading questions will improve your customer interviews. Find out more",
        "og_image": Blog7,
        "og_image_width": "1200",
        "og_image_height": "650"
    },
    "introducing-magic-ai-surveys": {
        "title": "Introducing Magic Feedback AI survey. Watch demo. ",
        "description": "Introducing Magic Feedback's AI Survey. Learn how our AI survey works. Uncover deeper customer insights with real-time AI follow-up questions. Watch demo.",
        "og_title": "Introducing Magic Feedback AI survey. Watch demo. ",
        "og_description": "Introducing Magic Feedback's AI Survey. Learn how our AI survey works. Uncover deeper customer insights with real-time AI follow-up questions. Watch demo.",
        "og_image": Blog8,
        "og_image_width": "1200",
        "og_image_height": "650"
    },
    "create-your-first-ai-survey": {
        "title": "Create your first Magic Feedback AI survey. Watch demo. ",
        "description": "Learn how to create your first AI survey. Understand how you can receive more in-depth customer insights with real-time AI follow-up questions. Watch demo. ",
        "og_title": "Create your first Magic Feedback AI survey. Watch demo. ",
        "og_description": "Learn how to create your first AI survey. Understand how you can receive more in-depth customer insights with real-time AI follow-up questions. Watch demo. ",
        "og_image": Blog9,
        "og_image_width": "1200",
        "og_image_height": "650"
    },
    "how-to-build-better-products-by-creating-a-strong-story": {
        "title": "Vanessa Damblemont. How to craft product story. Learn more",
        "description": "Vanessa Desi Damblemont advice on crafting a compelling product story. Learn how to build better products by creating a strong product story. Find out more. ",
        "og_title": "Vanessa Damblemont. How to craft product story. Learn more",
        "og_description": "Vanessa Desi Damblemont advice on crafting a compelling product story. Learn how to build better products by creating a strong product story. Find out more. ",
        "og_image": Blog10,
        "og_image_width": "1200",
        "og_image_height": "650"
    }
    /*
    "": {
        "title": "",
        "description": "",
        "og_title": "",
        "og_description": ""
    },
    */
}
